import { Component, Input, OnInit } from '@angular/core';
import { TypeSafeFormBuilder, TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { HeapService, TrackingEventNames, TrackingPropertyNames } from '@yourcause/common/heap';
import { YCModalComponent } from '@yourcause/common/modals';
import { PageHelpModalService } from '../page-help-modals.service';
import { PageHelpRoutes } from '../page-help-modals.typing';
interface PageHelpDismissGroup {
  dismissHelp: boolean;
}

@Component({
  selector: 'gc-page-help-modal',
  templateUrl: './page-help-modal.component.html',
  styleUrls: ['./page-help-modal.component.scss']
})
export class PageHelpModalComponent extends YCModalComponent<boolean> implements OnInit {
  @Input() route: PageHelpRoutes;

  modalHeader: string;
  modalContent: string;
  formGroup: TypeSafeFormGroup<PageHelpDismissGroup> = this.formBuilder.group<PageHelpDismissGroup>({
    dismissHelp: false
  });

  constructor (
    private pageHelpModalService: PageHelpModalService,
    private formBuilder: TypeSafeFormBuilder,
    private heapService: HeapService
  ) {
    super();
  }

  ngOnInit () {
    const helpers = this.pageHelpModalService.getHelpContentByRoute(this.route);
    this.modalHeader = helpers.modalHeader;
    this.modalContent = helpers.modalContent;
  }
  
  close () {
    const dismissed = this.formGroup.value.dismissHelp;
    
    // track event
    this.heapService.track(
      TrackingEventNames.PageHelpModal,
      {
        [TrackingPropertyNames.Name]: this.modalHeader,
        [TrackingPropertyNames.Dismissed]: String(dismissed)
      });
    
    this.closeModal.emit(dismissed);
  }
}
